<template lang="pug">
    div
        v-snackbar(
            v-model='snackbar.show'
            :color='snackbar.color'
            :timeout="snackbar.timeout"
            top
        )
            | {{ snackbar.text }}
            v-btn(dark text @click='snackbar.show = false')
                | Close
        template(v-if="isWaitingPhoneCall")
            v-card.ma-4(
                v-for='(ccq, idx) in callsWaiting'
                :key='ccq.call_communication_queue_id'
                shaped
                v-bind:style="{ border: '1px solid ' + holdColor(ccq) }"
            )
                v-system-bar(
                    :color="holdColor(ccq)"
                    dark
                )
                    v-icon.ml-1.text-white
                        template(v-if="ccq.status === 'ivr_callback'") mdi-phone-outgoing
                        template(v-else) mdi-phone-incoming
                    span.text-white
                        template(v-if="(ccq.hold_time_in_seconds || 0) < 600")
                            strong {{ (ccq.hold_time_in_seconds || 0) | secondsToFullWords }}
                        Timeago(
                            v-else
                            :datetime="ccq.start_time"
                            :auto-update="60"
                        )
                    v-spacer
                    v-btn(icon @click="ccq.is_maximized = !ccq.is_maximized;")
                        v-icon.text-white(v-if="ccq.is_maximized") mdi-window-minimize
                        v-icon.text-white(v-else) mdi-window-maximize

                v-toolbar(
                    :color="holdColor(ccq)"
                    dark
                    dense
                )
                    v-toolbar-title 
                        | {{ idx + 1 }}. {{ ccq.organization_name }}
                        template(v-if="ccq.canceled_missed_call_id > 0")
                            v-tooltip(top)
                                template(v-slot:activator='{ on, attrs }')
                                    span.ml-2(v-bind="attrs" v-on="on" role="text")
                                        v-icon mdi-phone-missed
                                span Previous Missed Call
                    v-spacer
                    template(v-if="liveDashboardInboundCallsEnabled")
                        v-tooltip(top)
                            template(v-slot:activator='{ on, attrs }')
                                span(v-bind="attrs" v-on="on" role="text")
                                    v-btn(icon ripple @click='takeCallWaitingFromLiveDashboard(ccq);')
                                        v-icon mdi-phone-check
                            span Take Call

                v-card-text(v-if="ccq.is_maximized")
                    template
                        v-list(two-line)
                            template
                                v-list-item
                                    v-list-item-content
                                        v-list-item-title {{ ccq.organization_name }}
                                        v-list-item-subtitle.text--primary(v-text='ccq.campaign_name')

                            template
                                v-divider(inset)
                                v-list-item
                                    v-list-item-icon
                                        v-icon(color='primary')
                                            | mdi-phone
                                    v-list-item-content
                                        v-list-item-title {{ ccq.communication_queue_name }}
                                        v-list-item-subtitle {{ ccq.language_name }}

                            template
                                v-divider(inset)
                                v-list-item
                                    v-list-item-icon
                                        v-icon(color='primary')
                                            | mdi-account
                                    v-list-item-content
                                        v-list-item-title {{ ccq.customer_phone_number | tel }}
                                        v-list-item-subtitle Caller ID
                                v-list-item
                                    v-list-item-icon
                                    v-list-item-content
                                        v-list-item-title {{ customerName(ccq) }}
                                        v-list-item-subtitle Name

                            template(v-if="ccq.canceled_missed_call_id > 0")
                                v-divider(inset)
                                v-list-item
                                    v-list-item-icon
                                        v-icon(color='error')
                                            | mdi-alert
                                    v-list-item-content
                                        v-list-item-title.error--text
                                            strong
                                                Timeago(
                                                    :datetime="ccq.canceled_missed_call_created_at"
                                                )
                                        v-list-item-subtitle.error--text Previous Missed Call
                            template(v-if="currentUserIsSuperAdmin")
                                v-divider()
                                v-list-item
                                    v-list-item-title.error--text
                                        strong
                                            | Triage Call
                                    v-btn.ma-2(color="red" outlined ripple @click='clearStuckCallCallQueue(ccq);')
                                        v-icon mdi-delete-empty
                                        | Clear Call

        v-alert.mx-lg-auto.mt-md-4.mb-md-4(v-else type="success")
            | There are not currently any calls waiting

</template>

<script lang="ts">
    import Vue from 'vue';
    import VolieState from '@/store';

    // data
    import { ClearStuckCallCallQueue, TakeCallWaitingFromLiveDashboard } from "@/data";

    export default Vue.extend({
        data() {
            return {
                isLoading: false,
                snackbar: {
                    show: false,
                    timeout: 2500,
                },
            }
        },
        methods: {
            customerName(ccq) {

                // Verify
                if (!ccq) {
                    return;
                }

                // Init
                const pieces = [];

                // Lead check
                if (ccq.is_outbound_lead === true) {
                    pieces.push("(LEAD)")
                }

                // Customer
                if (ccq.customer_id > 0) {
                    pieces.push(ccq.customer_full_name);
                } else if (ccq.customer_match_code === 2) {
                    pieces.push("Multiple potentials found");
                } else if (ccq.customer_match_code === 3) {
                    pieces.push("No Customer Matches");
                } else {
                    pieces.push("Unknown");
                }

                return pieces.join(" ");
            },
            holdColor(ccq) {

                // Init
                const seconds = (ccq?.hold_time_in_seconds || 0);

                // alert error
                if (seconds >= 90) {
                    return "var(--error)";
                }

                // alert warning
                if (seconds >= 30) {
                    return "var(--orange)";
                }

                // alert success
                return "var(--success)";
            },
            clearStuckCallCallQueue(ccq) {

                ClearStuckCallCallQueue(ccq.call_communication_queue_id).then((response) => {
                    if (response?.Error === null) {
                        this.showSnackbar("success", "Successfully updated removed call from queue");
                    } else {
                        let err = "Unable to update removed call from queue"
                        if (response?.Error?.length > 0) {
                            err = response.Error
                        }
                        this.showSnackbar("error", err);
                    }

                });
            },
            showSnackbar(color, text) {
                if (color?.length > 0 && text?.length > 0) {
                    this.snackbar.color = color;
                    this.snackbar.text = text;
                    this.snackbar.show = true;
                }
            },
            takeCallWaitingFromLiveDashboard(ccq) {

                if (!ccq || !ccq.call_communication_queue_id || (ccq.status !== "waiting" && ccq.status !== "ivr_callback")) {
                    return;
                }

                const call_call_queue_id = ccq.call_communication_queue_id;
                TakeCallWaitingFromLiveDashboard(call_call_queue_id).then((response) => {
                    if (response?.Data?.ok === true) {
                        if (response?.Data?.call?.assigned_campaign_customer?.campaign_customer_active_id > 0 || response?.Data?.call?.assigned_campaign_customer?.campaign_customer_id > 0) {
                            this.setCurrentCampaignCustomer(response.Data.call.assigned_campaign_customer);
                        } else {
                            this.setAsCallWithoutCustomer()
                        }

                        // Bubble up role
                        this.setSupervisorRole("inbound")
                        if (response.Data.call?.call?.id > 0) {
                            this.setCurrentCall(response.Data.call)
                        }

                        if (response.Data.web_rtc_participant?.id > 0 && response.Data.web_rtc_session?.id > 0) {
                            this.setCurrentWebRtcParticipant(response.Data.web_rtc_participant)
                            this.setCurrentWebRtcSession(response.Data.web_rtc_session)
                        }

                    } else {
                        this.showSnackbar("error", "Unable to take call from live dashboard calls waiting");
                    }
                });
            },
        },
        computed: {
            currentUser() {
                return VolieState.currentUser();
            },
            currentUserIsSuperAdmin() {
                return this.currentUser?.activated_role_id === 1;
            },
            isWaitingPhoneCall() {
                return this.callsWaiting?.length > 0;
            },
        },
        components: {
        },
        props: {
            callsWaiting: Array,
            liveDashboardInboundCallsEnabled: Boolean,
            setAsCallWithoutCustomer: Function,
            setCurrentCall: Function,
            setCurrentCampaignCustomer: Function,
            setCurrentWebRtcParticipant: Function,
            setCurrentWebRtcSession: Function,
            setSupervisorRole: Function,
        },
        watch: {
        },
        destroyed() {
        },
        created() {
        },
        mounted() {
        },
    });
</script>

<style lang="scss" scoped>
    #app {
        .cell-value-spacing {
            padding: 0 0 5px 0;
        }
    }
    
    :deep(.v-toolbar__content) {
        padding-right: 0 !important;
    }
</style>
